import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button, EmptyState } from '@brimostech/ui';
import { ApiError } from '@/lib/api-client';

interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}

/** Error state with a plain-language explanation and a retry action. */
export function ErrorState({
  error,
  onRetry,
  title = 'Não foi possível carregar',
}: ErrorStateProps) {
  const message =
    error instanceof ApiError ? error.message : 'Algo deu errado. Tente novamente em instantes.';
  return (
    <EmptyState
      icon={<AlertTriangle />}
      title={title}
      description={message}
      action={
        onRetry ? (
          <Button variant="outline" onClick={onRetry}>
            <RefreshCw /> Tentar de novo
          </Button>
        ) : undefined
      }
    />
  );
}
